import config from 'Cloud/config';
import React, { type ReactElement, memo, useCallback } from 'react';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { BaseInputDialog } from 'reactApp/components/BaseConfirmDialog/BaseInputDialog';
import { NEW_FOLDER_DEFAULT_NAME } from 'reactApp/constants/magicIdentificators';
import { noop } from 'reactApp/utils/helpers';

import styles from './FamilyFolderModal.css';
import type { FamilyFolderModalProps } from './FamilyFolderModal.types';

const MAX_NAME_LENGTH = config.get('ITEM_NAME_MAX_LENGTH');

export const FamilyFolderModal = memo(
    ({
        showCreateButton,
        createFolder,
        onClose,
        title = 'Создание семейной папки',
        description = 'Доступна всем участникам подписки',
        placeholder,
        folderName = NEW_FOLDER_DEFAULT_NAME,
        buttons = [EButtonType.accept],
    }: FamilyFolderModalProps): ReactElement => {
        const renderHeader = () => {
            return (
                <div className={styles.titleBlock}>
                    <span className={styles.title}>{title}</span>
                    <span className={styles.description}>{description}</span>
                </div>
            );
        };

        const onSuccessCallback = useCallback(
            (folderName) => {
                return createFolder(folderName, !showCreateButton);
            },
            [createFolder, showCreateButton]
        );

        return (
            <BaseInputDialog
                dataQAId="family-folder-modal"
                renderHeader={renderHeader}
                successButtonText="Создать"
                buttons={buttons}
                onSuccess={onSuccessCallback}
                selectionRange={folderName.length}
                maxLength={MAX_NAME_LENGTH}
                value={folderName}
                onClose={onClose}
                renderContent={noop}
                placeholder={placeholder}
            />
        );
    }
);

FamilyFolderModal.displayName = 'FamilyFolderModal';
